import { FlexBox } from '@dixa/lib-shared-habla';
import {
  PeriodControl,
  QuickViewControls as QuickViewControlsT,
  SettingsControl,
} from 'lib-analytics-types';
import { memo, useCallback } from 'react';

import { AnalyticsPeriod } from 'app/views/layout/views/analytics/components/controls/components/period/analyticsPeriod';

type QuickViewControlsProps = {
  controls?: QuickViewControlsT;
  onChangeControls: (controls: QuickViewControlsT) => void;
};

export const QuickViewControls = memo(function QuickViewControls({
  controls,
  onChangeControls,
}: QuickViewControlsProps): JSX.Element {
  const handleChangePeriod = useCallback(
    (period: PeriodControl): void => {
      onChangeControls({ period });
    },
    [onChangeControls],
  );

  const handleChangeSettings = useCallback(
    (settings: SettingsControl, period?: PeriodControl): void => {
      onChangeControls({
        settings: {
          ...controls?.settings,
          ...settings,
        },
        ...(period && { period }),
      });
    },
    [controls?.settings, onChangeControls],
  );

  const handleClear = useCallback((): void => {
    onChangeControls(null);
  }, [onChangeControls]);

  return (
    <FlexBox alignItems="center" gap="200">
      <AnalyticsPeriod
        period={controls?.period}
        settings={controls?.settings}
        placeholder="Default period"
        onChangePeriod={handleChangePeriod}
        onChangeSettings={handleChangeSettings}
        onClear={handleClear}
      />
    </FlexBox>
  );
});
